/**
 * @generated SignedSource<<7116c57a680dd108dab764ebba71eb9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbRespRecentSales_creatorRootPage$data = {
  readonly CreatorRootTransactions: {
    readonly recentSales: ReadonlyArray<{
      readonly categories: ReadonlyArray<string | null> | null;
      readonly creationDate: string | null;
      readonly medium: ReadonlyArray<string | null> | null;
      readonly period: string | null;
      readonly soldDate: string | null;
      readonly soldPrice: number | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecentSalesOverview_creatorRootTransactions">;
  } | null;
  readonly verticals: ReadonlyArray<VerticalType | null> | null;
  readonly " $fragmentType": "SbRespRecentSales_creatorRootPage";
};
export type SbRespRecentSales_creatorRootPage$key = {
  readonly " $data"?: SbRespRecentSales_creatorRootPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRecentSales_creatorRootPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRecentSales_creatorRootPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verticals",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorRootTransactions",
      "kind": "LinkedField",
      "name": "CreatorRootTransactions",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRecentSalesOverview_creatorRootTransactions"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RecentSalesTransaction",
          "kind": "LinkedField",
          "name": "recentSales",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "soldDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "soldPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categories",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "medium",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "creationDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "period",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorRootPage",
  "abstractKey": null
};

(node as any).hash = "da1ecc89b352c309a973a375791b89cf";

export default node;
